import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const membershipPlanUserMenuRegistry = {
    core_membershipPlanUser: {
        label: "Membership Plan User",
        link: PAGE_URL.MEMBERSHIP_PLAN_USER_PAGE,
        key: PAGE_URL.MEMBERSHIP_PLAN_USER_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default membershipPlanUserMenuRegistry;
